"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortMemorizePayeeList = exports.getMemorizedRuleType = exports.getMemorizedRuleWithSamePayeeName = exports.isComplexRule = void 0;
const immutable_1 = require("immutable");
const types_1 = require("./types");
const isComplexRule = (memorizePayeeRule) => { var _a; return Boolean((memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.amountCondition) || ((_a = memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.accountIds) === null || _a === void 0 ? void 0 : _a.length)); };
exports.isComplexRule = isComplexRule;
const getMemorizedRuleWithSamePayeeName = (rules, payeeName) => {
    const trimmedName = (payeeName !== null && payeeName !== void 0 ? payeeName : '').trim();
    if (!trimmedName) {
        return (0, immutable_1.Map)(); // return empty map if payeeName is empty
    }
    return rules.filter((rule) => { var _a; return ((_a = rule.payee) !== null && _a !== void 0 ? _a : '').trim() === trimmedName; });
};
exports.getMemorizedRuleWithSamePayeeName = getMemorizedRuleWithSamePayeeName;
const getMemorizedRuleType = (memorizePayeeRule) => {
    var _a, _b;
    let ruleType = types_1.MemorizedRuleType.NORMAL;
    if ((memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.amountCondition) && ((_a = memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.accountIds) === null || _a === void 0 ? void 0 : _a.length)) {
        ruleType = types_1.MemorizedRuleType.ACCOUNT_AND_AMOUNT_TYPE;
    }
    else if (memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.amountCondition) {
        ruleType = types_1.MemorizedRuleType.AMOUNT_TYPE;
    }
    else if ((_b = memorizePayeeRule === null || memorizePayeeRule === void 0 ? void 0 : memorizePayeeRule.accountIds) === null || _b === void 0 ? void 0 : _b.length) {
        ruleType = types_1.MemorizedRuleType.ACCOUNT_TYPE;
    }
    return ruleType;
};
exports.getMemorizedRuleType = getMemorizedRuleType;
const sortMemorizePayeeList = (ord, attr, mp) => {
    const sorted = mp.sort((a, b) => {
        const valA = a[attr];
        const valB = b[attr];
        if (valA == null && valB == null)
            return 0;
        if (valA == null)
            return ord === 'asc' ? 1 : -1;
        if (valB == null)
            return ord === 'asc' ? -1 : 1;
        // If the column is 'amount', use numeric comparison
        if (attr === 'amount') {
            const numA = Number(valA);
            const numB = Number(valB);
            return ord === 'asc' ? numA - numB : numB - numA;
        }
        // Fallback to localeCompare for strings
        const strA = String(valA);
        const strB = String(valB);
        const cmp = strA.localeCompare(strB, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
        return ord === 'asc' ? cmp : -cmp;
    });
    return sorted;
};
exports.sortMemorizePayeeList = sortMemorizePayeeList;
